import React from 'react'
import { GoDash } from 'react-icons/go'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'

export default function HomeFutureMineralsPricesChange({ change }) {
  if (change > 0) {
    return (
      <div className="border-success text-success flex justify-between whitespace-nowrap border-2 bg-success-600 bg-success-600/20 ltr:flex-row-reverse">
        <div
          className="px-2"
          dir="ltr"
        >
          {change} %
        </div>
        <div className="bg-success-600 p-1 text-white">
          <MdArrowUpward />
        </div>
      </div>
    )
  } else if (change < 0) {
    return (
      <div className="flex justify-between whitespace-nowrap border-2 border-danger-600 bg-danger-600/20 text-danger-600 ltr:flex-row-reverse">
        <div
          className="px-2"
          dir="ltr"
        >
          {change} %
        </div>
        <div className="bg-danger-600 p-1 text-white">
          <MdArrowDownward />
        </div>
      </div>
    )
  } else {
    return (
      <div className="flex justify-between whitespace-nowrap border-2 border-primary-600 bg-primary-600 bg-primary-600/20 text-primary-600 ltr:flex-row-reverse">
        <div
          className="px-2"
          dir="ltr"
        >
          {change} %
        </div>
        <div className="bg-primary-600 p-1 text-white">
          <GoDash />
        </div>
      </div>
    )
  }
}
